/**
* Helreps Functions for API
* and general api requests
*/
export default function () {
  const { confGlobal } = useConfig()
  const { $member, $i18n: i18n, $ip } = useNuxtApp()
  const { isMobile } = useDevice()
  const { useCustomCookie } = useCustomTools()
  const { fullPath } = useRoute()

  const disableCache = useCustomCookie('disableCache')
  const referrer = useCustomCookie('referrer')

  /**
  * Member Token
  */
  const memberToken = useState('memberToken', () => false)

  /**
  * External Member Token
  */
  const externalMemberToken = useState('externalMemberToken', () => false)

  /**
  * Headers for requests
  */
  const requestHeaders = (options = {}, isProxy) => {
    const headers = {
      'store-id': confGlobal.site.toUpperCase(),
      'content-type': 'application/json',
      'Accept-Language': i18n?.locale?.value,
      'Referer': referrer.value
        ? `${confGlobal.currentSiteUrl}${referrer.value}`
        : `${confGlobal.currentSiteUrl}${fullPath}`,
      'X-Referer': referrer.value
        ? `${confGlobal.currentSiteUrl}${referrer.value}`
        : `${confGlobal.currentSiteUrl}${fullPath}`,
      'X-IP': $ip,
      'X-Source-URL': `${confGlobal.currentSiteUrl}${fullPath}`
    }

    /**
    * Member Token
    */
    memberToken.value =
      externalMemberToken.value?.token
        ? externalMemberToken.value?.token
        : options.Authorization
          ? options.Authorization
          : $member?.memberToken.value
            ? $member.memberToken.value
            : false
    
    headers.Authorization = memberToken.value || 'Public'

    /**
    * Header with Customer Id for caching
    */
    if ($member?.user?.value?.id && isProxy && headers.Authorization !== 'Public') { 
      headers['customer-id'] = $member?.user?.value?.id
    }

    /**
    * Admin Auth
    */
    const adminToken = options['Admin-Token'] ? options['Admin-Token'] : $member?.adminToken?.value
    const customerUuid = options['Customer-Uuid'] ? options['Customer-Uuid'] : $member?.customerUuid?.value

    if (typeof adminToken === 'string' && typeof customerUuid === 'string') { 
      headers['Admin-Token'] = adminToken
      headers['Customer-Uuid'] = customerUuid
    }

    /**
    * Additional Headers
    */
    if (isMobile) {
      headers['Is-Mobile'] = true
    }

    if (disableCache.value || confGlobal.ISRPreset) {
      headers['Is-Test'] = true
    }

    const newHeaders = Object.assign(headers, options)
    if (newHeaders['content-type'] === false) {
      delete newHeaders['content-type']
    }

    return newHeaders
  }

  /**
  * Caching Options for Requests
  */
  const requestsCachingOptions = (key) => {
    const nuxtApp = useNuxtApp()

    const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

    if (!data) { return }

    const expirationDate = new Date(data.fetchedAt)
    expirationDate.setTime(expirationDate.getTime() + 5 * 1000 * 60)
    const isExpired = expirationDate.getTime() < Date.now()

    if (isExpired) { return }

    return data
  }

  /**
  * Return Object
  */
  return {
    externalMemberToken,
    memberToken,

    requestHeaders,
    requestsCachingOptions
  }
}
